import type { FaireProductEntity } from "../../entity_types/product";

export const p_uqqex2gzt8: FaireProductEntity = {
  token: "p_uqqex2gzt8",
  type: "product",
  name: "Duffle Bag(Embroidery)–Travel & Gym-Waterproof",
  brandToken: "b_4hfzm6sugt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/010c813693cb27101107b32a6f30771c9127451062746c5540e2b0bbdb79ef3f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31f1a9c66c395d75e030cfd2f456b144e5a3c4efd0efa84ab1980aae4336d32a.jpeg",
    "https://cdn.faire.com/fastly/2f90f0e7b68eca75cbbcec88c208aefcca0d06dffe2858be77c22a4be15d5253.jpeg",
    "https://cdn.faire.com/fastly/e37306509056c46aec92f978e1d792261f88985d2b772989f7fb2d0949bad075.jpeg",
    "https://cdn.faire.com/fastly/04a26d407e999822ff0c98f812756c669ace39ce489298e2eb34408a63aa8dea.jpeg",
    "https://cdn.faire.com/fastly/cade671fcf1b720a6434d2f75727e817e8e8709cf7c8cdd4b6791e338799d2a3.jpeg",
    "https://cdn.faire.com/fastly/66323d0bcc9a1817bbe80099713ef5a8c62d8f4bbfd7077de764ec678f2595d0.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "This item is available with or without customization. We offer embroidery personalization so customers can choose a non-custom version or add their own embroidered design for a unique touch.\n",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:41.083Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
